class ArticleList extends HTMLElement {
  constructor() {
    super();

    this.articles = this.querySelectorAll('[js-article]');

    this.toggle = this.querySelector('[js-toggle]');
    this.toggleSpan = this.querySelector('[js-toggle] span');

    this.shownAmount = this.toggle?.dataset.shownAmount;
    this.shownText = this.toggle?.dataset.shownText;
    this.hiddenText = this.toggle?.dataset.hiddenText;

    this.listeners();
  }

  listeners() {
    this.toggle?.addEventListener('click', () => (this.toggle.classList.contains('active') ? this.hideArticles() : this.showArticles()));
  }

  showArticles() {
    this.toggle.classList.add('active');
    this.articles.forEach((el) => el.classList.contains('hidden') === true && el.classList.remove('hidden'));
    this.toggleSpan.textContent = this.hiddenText;
  }

  hideArticles() {
    this.toggle.classList.remove('active');
    this.articles.forEach((el, index) => index >= this.shownAmount && el.classList.add('hidden'));
    this.toggleSpan.textContent = this.shownText;
  }
}

customElements.define('article-list', ArticleList);
